// **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "insert",
        regionType:  "region_name_currency_symbol",
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "shop_base",
        hasFlag: "no",
        selectorFlagMap: {'en': 'en', 'es': 'es'},
        displayType: "language_code",
        fontColor: "#000000",
        backgroundColor: "#c30a0a",
        backgroundOpacity: "0.0",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market_language",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",
        defaultRegion: "ES",
        primaryRegionById: {},
        availableRegionsByCode: {},
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "Spain", "code": "ES", "currency": {"code": "EUR", "symbol": "\u20ac"}, "languages": {"English": {"name": "English", "native_name": "English", "code": "en", "default": true}, "Espa\u00f1ol": {"name": "Espa\u00f1ol (Spanish)", "native_name": "Espa\u00f1ol", "code": "es", "default": false}}, "primary": true}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
        